export class Config {
  private static getEnvironment() {
    const hostname = window.location.hostname;
    if (hostname === 'heq-entry-web.keyclops.com') {
      return 'production';
    } else {
      return 'development';
    }
  }

  public static API_URL = (() => {
    if (Config.getEnvironment() === 'production') {
      return process.env.REACT_APP_API_URL;
    } else {
      return process.env.REACT_APP_DEV_API_URL;
    }
  })();

  public static SOCKET_URL = (() => {
    if (Config.getEnvironment() === 'production') {
      return process.env.REACT_APP_SOCKET_SERVER_URL;
    } else {
      return process.env.REACT_APP_DEV_SOCKET_SERVER_URL;
    }
  })();

  public static KAKAO_MAP_APP_KEY = process.env.REACT_APP_KAKAO_MAP_APP_KEY;
}
